// Module
var code = "<div id=\"wrapper\" block-ui=\"main\"> <div id=\"sidebar-decoy\"></div> <sticky-header-admin></sticky-header-admin> <div id=\"page-wrapper\" class=\"container\" ui-view></div> <sticky-footer id=\"sticky-bottom\"></sticky-footer> </div> ";
// Exports
module.exports = code;